export default __webpack_public_path__ + "static/FuturaBookRegular-29d48ee97a2707f0f4cc9766b8f9b8f4.otf";